import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '@app/model/product';
import { EmailService } from '@app/services/Email/email.service';
import { PaymentService } from '@app/services/Payment/payment.service';
import { environment } from './../../../../environments/environment.prod';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnInit {
  razorPayKey: any;
  price:any;
  selectedProduct!: Product;

  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private emailService: EmailService
) {}
  
  ngOnInit() {
    //this.getRazorPayKey();
    this.listenSelectedProduct();
    this.getOrderId();
  }

  getRazorPayKey() {
    this.paymentService.getRazorPayKey().subscribe((response: any) => {
      this.razorPayKey = environment.RAZORPAY_KEY_ID;
      //this.razorPayKey = response['RAZORPAY_KEY_ID'];
    });
  }

  getOrderId() {
    return this.route.snapshot.params['paymentOrderId'];
  }

  listenSelectedProduct() {
    this.selectedProduct = this.paymentService.getSelectedProductForCheckout();
    this.price = this.selectedProduct?.sellProductPrice
  }

  payWithRazorpay(price:any) {
    const paymentOrderId = this.getOrderId();
    //const paymentOrderId = 'bimPlanOrder'+Math.random().toString(36).substr(2, 5);
    const options: any = {
      key: this.razorPayKey,
      amount: price * 100, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: 'BIM', // company name or product name
      description: '', // product description
      image: './../../assets/images/bim-icon.png', // company logo or product image
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      prefill: {
        "email": 'test@gmail.com',
        "name": 'test',
        "contact": '9028081985'
      },
      notes: {
          "order_id": 'bimProductOrder'+Math.random().toString(36).substr(2, 5),
          "payment_type": "Plan"
      },
      theme: {
        color: '#6DB6FD',
      },
    };

    options.handler = (response: any, error: any) => {
      options.response = response;
      if (error) {
        Swal.fire({
          title: `Payment has been failed.`,
          icon: "error",
          showConfirmButton: false,
          timer: 2000
        });
        //this.router.navigateByUrl('paymentfailed');
      } else {
        this.paymentService.verifyPaymentSignature(response, paymentOrderId)
          // .subscribe((response: any) => {
          //   response.data.isPaymentVerfied
          //     ? this.router.navigateByUrl('paymentsuccess')
          //     : this.router.navigateByUrl('paymentfailed');
          // }
          //);
          .subscribe((response: any) => {
            response.data.isPaymentVerfied
              ? Swal.fire({
                title: `Payment has been successfully processed.`,
                icon: "success",
                showConfirmButton: false,
                timer: 3000
              },)
              : Swal.fire({
                title: `Payment has been failed.`,
                icon: "error",
                showConfirmButton: false,
                timer: 2000
              });
          })
      }
      // call your backend api to verify payment signature & capture transaction
    };
    options.modal.ondismiss = () => {
      // handle the case when user closes the form while transaction is in progress
      //alert('Transaction has been cancelled.');
      Swal.fire({
        title: `Transaction has been cancelled.`,
        icon: "error",
        showConfirmButton: false,
        timer: 2000
      });
      this.router.navigateByUrl('cart');
    };
    const rzp = new this.paymentService.nativeWindow.Razorpay(options);
    rzp.open();
  }

  saveAndEmailPricePlan(userInfoId:any, businessEmail:any, planType:any, paymentId:any, price:any) {
    this.emailService.saveAndEmailPricePlan(userInfoId, businessEmail, planType, paymentId, price ).subscribe({
      next: (response: any) => {
        if (response) {
          Swal.fire("Your order submitted successfully.");
        }
      },
      error: (error: any) => {
        Swal.fire("Technical Issue, Try again.")
      }
    });
  }

  ngAfterViewInit() {
    var a = $(".bg");
    a.each(function (a) {
        if ($(this).attr("data-bg")) $(this).css("background-image", "url(" + $(this).data("bg") + ")");
    });
    
  }
}
